import { KeyValueTable } from "@/components/ui/key-value-table";
import { useMemo } from "react";
import type { McpToolInfo } from "./types";

interface ToolCallInfoProps {
  toolInfo: McpToolInfo;
}

export function ToolCallInfo({ toolInfo }: ToolCallInfoProps) {
  const kvArgs = useMemo(() => {
    return Object.entries(toolInfo.arguments).map(([key, value]) => ({
      name: key,
      value: String(value),
    }));
  }, [toolInfo.arguments]);

  if (!toolInfo.toolName && !toolInfo.methodName) {
    return null;
  }

  return (
    <div className="grid gap-2">
      <h4 className="text-sm font-medium text-foreground border-b pb-2">
        Tool Call Information
      </h4>
      <div className="grid grid-cols-[1fr_auto] @[400px]:grid-cols-[1fr_auto_1fr_auto] gap-4">
        {toolInfo.methodName && (
          <div className="contents">
            <span className="font-medium text-muted-foreground whitespace-nowrap">
              Method:
            </span>
            <div className="break-words overflow-hidden">
              {toolInfo.methodName}
            </div>
          </div>
        )}
        {toolInfo.toolName && (
          <div className="contents">
            <span className="font-medium text-muted-foreground whitespace-nowrap">
              Tool:
            </span>
            <div className="break-words overflow-hidden">
              {toolInfo.toolName}
            </div>
          </div>
        )}
        {toolInfo.requestId && (
          <div className="contents">
            <span className="font-medium text-muted-foreground whitespace-nowrap">
              Request ID:
            </span>
            <div className="break-words overflow-hidden">
              {toolInfo.requestId}
            </div>
          </div>
        )}
      </div>
      {Object.keys(toolInfo.arguments).length > 0 && (
        <KeyValueTable values={kvArgs} keyHeaderText="Argument" />
      )}
    </div>
  );
}
